function ChangePassword() {
    return (
      <div className="App">
      <h1>Change Password</h1>
      <p>this is the change password page</p>
      </div>
    );
  }
  
  export default ChangePassword;